<template>
    <div class="kgr-inputGroup">
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Kasse') }}
        </h3>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
        >
            {{ $t('club.salesListConfig.infoText') }}
        </div>

        <div class="kgr-grid__cell">
            <kgr-form-row
                :label="$t('Bitte wähle eine oder mehrere mögliche Zahlungsmethoden')"
                :error="error"
                field-name="paymentMethods"
            >
                <kgr-multi-select
                    v-model="selectedPaymentMethods"
                    :options="paymentMethods"
                    :multiple="true"
                    mode="tags"
                    @post-input="updateSelectedPaymentMethods()"
                />
            </kgr-form-row>
            <br /><br />
            <div
                class="kgr-alert kgr-alert--info kgr-row"
                v-html="$t('club.salesListConfig.items.infoText')"
            ></div>
            <kgr-form-row
                :label="$t('Bitte wähle eine oder mehrere Kategorien')"
                :error="error"
                field-name="clubFeeCategories"
            >
                <kgr-multi-select
                    v-model="selectedCategories"
                    :options="categoryOptions"
                    :multiple="true"
                    mode="tags"
                    @post-input="updateSelectedCategories()"
                />
            </kgr-form-row>

            <hr class="kgr-separator" />

            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('Übersicht der ausgewählten Beiträge') }}
            </h3>
            <kgr-club-sales-list-items
                :club-sales-list-items="clubSalesListItems"
                :is-editable="isEditable"
            />
        </div>
    </div>
</template>

<script>
import ClubSalesListConfig from '../../../js/dto/ClubSalesListConfig';
import ClubSalesListItems from './ClubSalesListItems';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import MultiSelect from '../../common/form/select/MultiSelect';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-multi-select': MultiSelect,
        'kgr-club-sales-list-items': ClubSalesListItems,
    },
    props: {
        clubSalesListConfig: {
            type: ClubSalesListConfig,
            required: true,
        },
        clubFeeCategories: {
            type: Array,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
        clubSalesListItems: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            selectedCategories: this.convertSelectedCategories(),
            selectedPaymentMethods: this.clubSalesListConfig.paymentMethods,
        };
    },
    computed: {
        categoryOptions() {
            return this.clubFeeCategories.map((category) => {
                return { value: category.id, label: category.name };
            });
        },
    },
    watch: {
        clubSalesListConfig() {
            this.selectedCategories = this.convertSelectedCategories();
        },
    },
    methods: {
        convertSelectedCategories() {
            return this.clubSalesListConfig.clubFeeCategories.map((category) => {
                return { value: category.id, label: category.name };
            });
        },
        updateSelectedCategories() {
            this.clubSalesListConfig.clubFeeCategories = this.selectedCategories.map(
                (category) => {
                    return { id: category.value, name: category.label };
                },
            );
        },
        updateSelectedPaymentMethods() {
            this.clubSalesListConfig.paymentMethods = this.selectedPaymentMethods.map(
                (method) => {
                    return { value: method.value, label: method.label };
                },
            );
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    hr {
    margin: 30px 0;
}
</style>
